import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Highway Alerts API
 */
export const wsdotHighwayAlertsApiMeta: ApiMeta = {
  name: "wsdot-highway-alerts",
  baseUrl:
    "https://www.wsdot.wa.gov/traffic/api/highwayalerts/highwayalertsrest.svc",
};
